// src/Home.js
import React, { useState } from 'react';
import ChatBubble from '../components/chatBubble';
import * as assistant from "../scripts/assistantCall.js" 

const ChatContainer = () => {

    const [messages, setMessages] = useState([]);

    const [userTextRequest, setUserTextRequest] = useState('');

    const [openaiKey, setOpenaiKey] = useState('');

    const [assistantID, setAssistantID] = useState('');

    const handleUserTextRequest = (e) => {
        setUserTextRequest(e.target.value);
    };
   
    const handleOpenAIKey = (e) => {
        setOpenaiKey(e.target.value);
    };

    const handleAssistantID = (e) => {
        setAssistantID(e.target.value);
    };

    function addUserMessage(message) {
        addMessage(message,false)
    }

    function addSystemMessage(message) {
        addMessage(message,true)
    }

    function addMessage(message, response) {
        setMessages(prev => [...prev, {text:message, isResponse:response}]);
    }

    function resetChat(){
        localStorage.removeItem('thread')
        setMessages([])
    }

    async function sendRequest(){
        let thread=localStorage.getItem('thread');
        let requestToSend = userTextRequest;
        addUserMessage(requestToSend)
        setUserTextRequest("")
        let response = await assistant.sendRequest(requestToSend,openaiKey,assistantID,thread)
        addSystemMessage(response)
    }
   
    return <>

        {/* 2.1) CHAT viewer */}
        <div className="chatContainer">
        <textarea
                    id="openaiKey"
                    className="keyInfoArea"
                    placeholder="Write here your openAi key..."
                    value={openaiKey}
                    onChange={handleOpenAIKey}
                >
                </textarea> <textarea
                    id="userInput"
                    className="keyInfoArea"
                    placeholder="Write here the assistant ID..."
                    value={assistantID}
                    onChange={handleAssistantID}
                >
                </textarea>
            <div className="chatMessageContainer">
            {messages.map((m, index) => (
                <ChatBubble key={index} isResponse={m.isResponse} text={m.text} />
            ))}
            </div>

            <div className='inputSection'>
            <button className="resetButton" onClick={()=>resetChat()}> Reset </button>
                <textarea
                    id="userInput"
                    className="inputArea"
                    placeholder="Write here your request..."
                    value={userTextRequest}
                    onChange={handleUserTextRequest}
                >
                </textarea>

                <button className="sendButton" onClick={()=>sendRequest()}> Send</button>
                
            </div>
        </div>
                
    </>
};
export default ChatContainer;
